import './detail.less';
import { useEffect, useState } from 'react';
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import { AUTH_MONITOR_LIST, AUTH_MENU_LIST } from '@/enums/auth';
import { getPositionDetail, updatePositionAuth } from '@/api/lib/position';
import TnMessage from '@/global/components/message';
import { Position } from '@/global/interface/project-manage/position';
import { Skeleton } from 'antd';

interface IProps {
    positionId: number
}

export default function LibPositionAuthDetail(props: IProps) {

    const [loading, setLoading] = useState<boolean>(false);
    const [auths, setAuths] = useState<number[]>([]);

    useEffect(() => {
        if (!props?.positionId) return;
        setLoading(true);
        getPositionDetail(props?.positionId).then(res => {
            let data: Position = res.data || null;
            if (data) {
                setAuths(data?.auths || []);
            }
        }).catch(err => {
            TnMessage.error("获取职位失败");
        }).finally(() => {
            setLoading(false);
        })
    }, [props?.positionId])


    const toggleAuth = (auth: number) => {
        if (!props?.positionId || !auth) return;
        let idx = auths?.findIndex(i => i === auth);
        if (idx === -1) {
            auths.push(auth);
            setAuths([...auths]);
        } else {
            auths.splice(idx, 1);
            setAuths([...auths]);
        }
        updatePositionAuth(props?.positionId, auth).then(res => {
            if (res.status === 200) {
                TnMessage.success("权限设置成功", { duration: 0.5 })
            }
        }).catch(err => {
            TnMessage.error("设置权限失败");
        })
    }

    return (
        <div className='lib-position-auth-detail-container'>
            {props?.positionId && <Skeleton loading={loading}>
                <div className="auth-row">
                    {AUTH_MONITOR_LIST.map((item, key) => (
                        <div className="auth-block" key={key}>
                            <div className="auth-icon" onClick={() => toggleAuth(item.value)}>
                                {auths?.some(i => i === item.value) && <CheckedSvg />}
                                {!auths?.some(i => i === item.value) && <CheckSvg />}
                            </div>
                            <div className="auth-text">{item.label}</div>
                        </div>
                    ))}
                </div>
                <div className="auth-row">
                    {AUTH_MENU_LIST.map((item, key) => (
                        <div className="auth-block" key={key}>
                            <div className="auth-icon" onClick={() => toggleAuth(item.value)}>
                                {auths?.some(i => i === item.value) && <CheckedSvg />}
                                {!auths?.some(i => i === item.value) && <CheckSvg />}
                            </div>
                            <div className="auth-text">{item.label}</div>
                        </div>
                    ))}
                </div>
            </Skeleton>}
        </div>
    )
}